import Vue from 'vue';
import Vuelidate from 'vuelidate';
import Notifications from 'vue-notification';
import vmodal from 'vue-js-modal';
import { i18n } from '@/i18n';
import { initialize as httpInitialize } from '@/api';
import router from './router';
import App from './App.vue';

import '@/inputmask';
import '@/assets/styles/index.scss';
import { cookies } from './plugins/cookies';
import { domain } from './plugins/domain';

Vue.config.productionTip = false;
Vue.prototype.$cookies = cookies;
Vue.prototype.$domain = domain;
Vue.use(Vuelidate);
Vue.use(vmodal);
Vue.use(Notifications, {
  componentName: 'VueNotifications',
});

export const VueInstance = new Vue({
  router,
  i18n,
  beforeCreate() {
    httpInitialize();
  },
  render: (h) => h(App),
}).$mount('#app');
